import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {
    MatBadgeModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatToolbarModule
} from '@cdk/angular/material';

import {ToolbarComponent} from './toolbar.component';
import {NotificacaoService} from '@cdk/services/notificacao.service';
import {AjudaComponent} from '../../../../ajuda/ajuda.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TourModule} from 'ajuda/tour/tour.module';
import {NavbarVerticalStyle1Module} from "../navbar/vertical/style-1/style-1.module";
import {ChatPanelModule} from "../chat-panel/chat-panel.module";
import {MatCheckboxModule} from '@angular/material/checkbox';
import { CdkSearchBarComponent } from '@cdk/components/search-bar/search-bar.component';
import { CdkShortcutsComponent } from '@cdk/components/shortcuts/shortcuts.component';
import { BarraPesquisaComponent } from '@cdk/components/barra-pesquisa/barra-pesquisa.component';


@NgModule({
    imports: [
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatListModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    CdkSearchBarComponent,
    CdkShortcutsComponent,
    MatTooltipModule,
    TourModule,
    NavbarVerticalStyle1Module,
    MatCheckboxModule,
    ChatPanelModule,
    BarraPesquisaComponent,
    ToolbarComponent
],
    providers: [
        NotificacaoService,
        AjudaComponent
    ],
    exports: [
        ToolbarComponent
    ],
})
export class ToolbarModule {
}
